<script lang="ts" setup>
const { size = "md", name } = defineProps<{
  name: string
  size?: "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "auto"
}>()

const modules = import.meta.glob("../assets/icons/**/*.svg", {
  query: "?raw",
  import: "default",
  eager: true,
})

const svg = computed(() => modules[`../assets/icons/${name}.svg`])

const svgHeight = computed(() => ({
  xxs: "14px",
  xs: "16px",
  sm: "18px",
  md: "20px",
  lg: "24px",
  xl: "48px",
  auto: "auto",
})[size])
</script>

<template>
  <span
    v-if="name"
    class="icon all-unset block"
    v-html="svg"
  />
</template>

<style>
.icon svg {
  width: auto;
  height: v-bind(svgHeight) !important;
}
</style>
